module.exports = __webpack_public_path__ + "static/media/cross.fec70481.svg";